module.exports = __webpack_public_path__ + "img/a1_1.2922cca5.png";